import { combine } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export type SellParams = { marketAddress: string; optionAddress: string };
export type RepliesOpenParams = { postUuid: string; total: number; lastId?: string };

// store
export const useModelStore = createWithEqualityFn(
  combine(
    {
      authOpen: false,
      sellOpen: false,
      sellParams: {
        marketAddress: '',
        optionAddress: '',
      } as SellParams,
      tradeOpen: false,
      searchOpen: false,
      repliesOpen: false,
      repliedParams: {
        postUuid: '',
        total: 0,
        lastId: '',
      } as RepliesOpenParams,
      walletOpen: false,
      depositOpen: false,
      // Login-method picker (Connect Wallet / Sign in with DID / future social)
      loginOpen: false,
      // DID onboarding wizard (connect wallet / fund / enable trading)
      onboardingOpen: false,
      // "How it works" explainer (header/more-menu entry, not auto-shown)
      howItWorksOpen: false,
      // Testnet faucet (wallet-balance/more-menu entry, testnet builds only)
      faucetOpen: false,
    },
    set => ({
      setAuthOpen: (authOpen: boolean) => set({ authOpen }),
      setLoginOpen: (loginOpen: boolean) => set({ loginOpen }),
      setOnboardingOpen: (onboardingOpen: boolean) => set({ onboardingOpen }),
      setHowItWorksOpen: (howItWorksOpen: boolean) => set({ howItWorksOpen }),
      setFaucetOpen: (faucetOpen: boolean) => set({ faucetOpen }),
      setSellOpen: (sellOpen: boolean) => set({ sellOpen }),
      setTradeOpen: (tradeOpen: boolean) => set({ tradeOpen }),
      setSellParams: (sellParams: SellParams) => set({ sellParams }),
      setSearchOpen: (searchOpen: boolean) => set({ searchOpen }),
      setRepliesOpen: (repliesOpen: boolean) => set({ repliesOpen }),
      setRepliedParams: (repliedParams: RepliesOpenParams) => set({ repliedParams }),
      setWalletOpen: (walletOpen: boolean) => set({ walletOpen }),
      setDepositOpen: (depositOpen: boolean) => set({ depositOpen }),
    })
  ),
  shallow
);
